import 'virtual:polyfills';
import React from 'react';
import { createRoot } from 'react-dom/client';
import 'wicg-inert';
import { registerSW } from 'virtual:pwa-register';
import { configureEnv } from '@jwp/ott-common/src/env';

import { register } from './modules/register';
import { initSentry } from './sentry';

import { attachAccessibilityListener } from '#src/utils/accessibility';

// Collect env vars
configureEnv({
  APP_VERSION: import.meta.env.APP_VERSION,

  APP_API_BASE_URL: import.meta.env.APP_API_BASE_URL,
  APP_CONFIG_API_BASE_URL: import.meta.env.APP_CONFIG_API_BASE_URL,
  APP_CONTENT_API_BASE_URL: import.meta.env.APP_CONTENT_API_BASE_URL,
  APP_ACCOUNT_API_BASE_URL: import.meta.env.APP_ACCOUNT_API_BASE_URL,
  APP_PLAYER_ID: import.meta.env.APP_PLAYER_ID,
  APP_EPG_DAY_ROLLOVER_HOUR: import.meta.env.APP_EPG_DAY_ROLLOVER_HOUR,

  APP_DEFAULT_CONFIG_SOURCE: import.meta.env.APP_DEFAULT_CONFIG_SOURCE,
  APP_PLAYER_LICENSE_KEY: import.meta.env.APP_PLAYER_LICENSE_KEY,

  APP_CONSENT_COOKIE_NAME: import.meta.env.APP_CONSENT_COOKIE_NAME,
  APP_CONSENT_COOKIE_POLICY_URL: import.meta.env.APP_CONSENT_COOKIE_POLICY_URL,

  APP_FOOTER_TEXT: import.meta.env.APP_FOOTER_TEXT,
  APP_BODY_FONT: import.meta.env.APP_BODY_FONT,
  APP_BODY_ALT_FONT: import.meta.env.APP_BODY_ALT_FONT,
  APP_PUBLIC_URL: import.meta.env.APP_PUBLIC_URL || window.location.origin,

  APP_GTM_TAG_ID: import.meta.env.APP_GTM_TAG_ID,
  APP_GTM_TAG_SERVER: import.meta.env.APP_GTM_TAG_SERVER,
  APP_GTM_LOAD_ON_ACCEPT: import.meta.env.APP_GTM_LOAD_ON_ACCEPT,
  APP_GTM_SCRIPT: import.meta.env.APP_GTM_SCRIPT,
  APP_GTM_COOKIE_BANNER: import.meta.env.APP_GTM_COOKIE_BANNER,

  APP_CHROMECAST_APPLICATION_ID: import.meta.env.APP_CHROMECAST_APPLICATION_ID,
  APP_DELETE_ACCOUNT_URL: import.meta.env.APP_DELETE_ACCOUNT_URL,
  APP_TERMS_AND_CONDITIONS_URL: import.meta.env.APP_TERMS_AND_CONDITIONS_URL,
  APP_EXTERNAL_LOGIN_PROVIDERS: import.meta.env.APP_EXTERNAL_LOGIN_PROVIDERS,

  APP_NAME: import.meta.env.APP_NAME,
  APP_SHORT_NAME: import.meta.env.APP_SHORT_NAME,
  APP_DESCRIPTION: import.meta.env.APP_DESCRIPTION,

  APP_MEDIA_PLAYLIST_SOURCE: import.meta.env.APP_MEDIA_PLAYLIST_SOURCE,
  APP_CUSTOM_USER_LINKS: import.meta.env.APP_CUSTOM_USER_LINKS,
  APP_HERO_SHELF_AUTO_SLIDE_INTERVAL: import.meta.env.APP_HERO_SHELF_AUTO_SLIDE_INTERVAL,
});

async function run() {
  await register();

  // initialize Sentry to have early error tracking
  await initSentry();

  attachAccessibilityListener();

  const { default: App } = await import('./App');
  const rootElement = document.getElementById('root');

  if (rootElement) {
    const root = createRoot(rootElement);
    root.render(<App />);
  } else {
    console.info('Application - rootElement not found');
  }
}

run();

const refresh = registerSW({
  immediate: true,
  onNeedRefresh: () => refresh(true),
});
